module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAqAgMAAAB937tZAAAADFBMVEV0aflzaPiAVf90afgsM4qNAAAAA3RSTlPtkAbDbqgCAAAALUlEQVQoz2OY/B8ZfGxgqP+PAhwY7FEFGBj+o4IDowKjAlQWwEh0GMkSI+ECAJDxjLVvOJvNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/S_icon.png
// module id = 9dMB
// module chunks = 167